import store from '../store';

export default function getRootItemId(itemId: string): string | undefined {
    return store.rootItemIdMap.get(itemId);
}
